import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  prefix: '+91',
  mobile: '',
  verifiedMobileToken: null,
};

const resetPasswordSlice = createSlice({
  name: 'resetPassword',
  initialState,
  reducers: {
    setResetStep1Data(state, action) {
      state.prefix = action.payload.prefix;
      state.mobile = action.payload.mobile;
      state.verifiedMobileToken = action.payload.verifiedMobileToken;
    },
    resetResetPasswordData() {
      return initialState;
    },
  },
});

export const { setResetStep1Data, resetResetPasswordData } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
